/**
 * Notification REST API helpers.
 *
 * customGetAPI(url)            — 1 param, token read from localStorage
 * customAPI(url, method, body) — 3 params, no token arg
 *
 * domain already ends with "/api/" (e.g. "http://localhost:8000/api/")
 * so all paths start with "v1/notifications/".
 *
 * A notification row's timestamp field is `created_at` (with underscore),
 * formatted as "DD-MM-YYYY hh:mm AM/PM" (e.g. "31-08-2026 05:06 PM") — not
 * ISO, so the native Date constructor can't parse it directly. Display code
 * must read n.created_at and go through
 * notificationUtils.js's parseNotificationTimestamp (via formatTime /
 * getNotificationDateGroup / formatNotificationTimestamp /
 * formatFullTimestamp), never n.createdat or a bare `new Date(n.created_at)`.
 */
import { customGetAPI, customAPI } from './CustomAPI';

export const fetchNotifications = (domain, page = 1) =>
  customGetAPI(`${domain}v1/notifications/?page=${page}&page_size=20`);

export const fetchUnreadCount = (domain) =>
  customGetAPI(`${domain}v1/notifications/unread-count/`);

export const markNotificationRead = (domain, notificationId) =>
  customAPI(
    `${domain}v1/notifications/mark-read/`,
    'POST',
    { notification_id: notificationId },
  );

export const markAllNotificationsRead = (domain) =>
  customAPI(
    `${domain}v1/notifications/mark-read/`,
    'POST',
    { all: true },
  );

export const fetchNotificationConfig = (domain) =>
  customGetAPI(`${domain}v1/notifications/config/`);

export const updateNotificationPreferences = (domain, preferences) =>
  customAPI(
    `${domain}v1/notifications/preferences/`,
    'PUT',
    { preferences },
  );
